import { Typography } from '@mui/material';
import React from 'react';

type SubtitleProps = {
  children: React.ReactNode;
};

const Subtitle: React.FC<SubtitleProps> = ({ children }) => (
  <Typography variant="h2">{children}</Typography>
);
export default Subtitle;
